export * from 'stores/search-base/mutation-types';
export const ADD_TO_BASKET = 'ADD_TO_BASKET';
export const REMOVE_FROM_BASKET = 'REMOVE_FROM_BASKET';
export const CLEAR_BASKET = 'CLEAR_BASKET';
export const SET_BASKET = 'SET_BASKET';
export const SET_FAVORITES = 'SET_FAVORITES';
export const SAVE_FAVORITE = 'SAVE_FAVORITE';
export const DELETE_FAVORITE = 'DELETE_FAVORITE';
export const REMOVE_RESULT = 'REMOVE_RESULT';
export const REPLACE_RESULT = 'REPLACE_RESULT';
export const SAVE_MSDS_SETTINGS = 'SAVE_MSDS_SETTINGS';
